import PropTypes from 'prop-types'
import {
  File as FileIcon,
  Check as CheckIcon,
  Loader as LoaderIcon,
  Moon as MoonIcon,
  X as XIcon,
} from 'react-feather'

import { InformativeCard } from 'components'

import palette from 'theme/palette'
import helpers from 'helpers'
import constants from 'constants/index'

const QuestionnaireInformativeCards = ({ questionnaire }) => {
  const activeQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: [
        constants.question.ANSWERED_STATUS,
        constants.question.PENDING_STATUS,
      ],
    },
  )
  const applicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: true,
    },
  )
  const answeredQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.question.ANSWERED_STATUS,
    },
  )
  const pendingQuestions = helpers.questionnaires.filterQuestions(
    applicableChoiceQuestions || [],
    {
      status: constants.question.PENDING_STATUS,
    },
  )
  const inactiveQuestions = helpers.questionnaires.filterQuestions(
    questionnaire?.questions || [],
    {
      status: constants.question.INACTIVE_STATUS,
    },
  )
  const notApplicableChoiceQuestions = helpers.questionnaires.filterQuestions(
    activeQuestions || [],
    {
      applicableChoice: false,
    },
  )

  const questions = {
    active: activeQuestions,
    applicableChoice: applicableChoiceQuestions,
    answered: answeredQuestions,
    pending: pendingQuestions,
    inactive: inactiveQuestions,
    notApplicableChoice: notApplicableChoiceQuestions,
  }

  const questionInfoCards = [
    {
      backgoundIconColor: palette.secondary.dark,
      icon: <FileIcon color={palette.white} size="18px" />,
      label: 'TODAS',
      value: questionnaire?.questions?.length || 0,
    },
    {
      backgoundIconColor: palette.greenPantone,
      icon: <CheckIcon color={palette.white} size="18px" />,
      label: 'RESPONDIDAS',
      value: questions.answered?.length || 0,
    },
    {
      backgoundIconColor: palette.azure,
      icon: <LoaderIcon color={palette.white} size="18px" />,
      label: 'PENDENTES',
      value: questions.pending?.length || 0,
    },
    {
      backgoundIconColor: palette.brightBlue,
      icon: <XIcon color={palette.white} size="18px" />,
      label: 'NÃO SE APLICAM',
      value: questions.notApplicableChoice?.length || 0,
    },
    {
      backgoundIconColor: palette.spanishGray,
      icon: <MoonIcon color={palette.white} size="18px" />,
      label: 'INATIVAS',
      value: questions.inactive?.length || 0,
    },
  ]

  return (
    <>
      {questionInfoCards.map((questionInfoCard) => (
        <InformativeCard
          key={questionInfoCard.label}
          backgoundIconColor={questionInfoCard.backgoundIconColor}
          icon={questionInfoCard.icon}
          label={questionInfoCard.label}
          value={questionInfoCard.value}
        />
      ))}
    </>
  )
}

QuestionnaireInformativeCards.propTypes = {
  questionnaire: PropTypes.object.isRequired,
}

export default QuestionnaireInformativeCards
